import { render, staticRenderFns } from "./CadastrarSala.vue?vue&type=template&id=a21d2c64&"
import script from "./CadastrarSala.vue?vue&type=script&lang=js&"
export * from "./CadastrarSala.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports